module.exports = __webpack_public_path__ + "static/media/toothbrush_and_toothpaste.c48be571.svg";